import { Helmet, HelmetProvider } from "react-helmet-async";

const CustomHelmet = ({ title }: { title: string }) => (
  <HelmetProvider>
    <Helmet>
      <title>{title} | کارن ترابر نت</title>
    </Helmet>
  </HelmetProvider>
);

export default CustomHelmet;
